<template>
  <div>
    <!-- <a-upload
      :action="element.options.action"
      :on-success="handleSuccess"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      multiple
      :limit="element.options.length"
      :headers="element.options.headers"
      :on-exceed="handleExceed"
      :file-list="dataModel"
      :disabled="element.options.disabled"
      :style="{'width': element.options.width}"
    >-->
    <a-upload
      :action="element.options.action"
      :change="handleSuccess"
      :disabled="element.options.disabled"
      :fileList="dataModel"
      :headers="element.options.headers"
      :preview="handlePreview"
      :remove="handleRemove"
      :style="{'width': element.options.width}"
      multiple
    >
      <div v-if="!preview">
        <a-button size="small" type="primary">点击上传</a-button>
        <div class="a-upload__tip" slot="tip">{{ element.options.tip }}</div>
      </div>
    </a-upload>
  </div>
</template>

<script>
  export default {
    name: 'FileUpload',
    // eslint-disable-next-line vue/require-prop-types
    props: ['element', 'preview', 'dataModel'],
    data () {
      return {
        fileListTmp: []
      }
    },
    methods: {
      handleRemove (file, fileList) {
        this.fileListTmp = fileList
        this.$emit('fileList', fileList)
      },
      handlePreview (file) {
        window.open(file.url, '_blank')
      },
      handleExceed (files, fileList) {
        this.$message.warning(`最多允许上传 ${this.element.options.length} 个文件。`)
      },
      beforeRemove (file, fileList) {
        return this.$confirm(`确定要移除 ${file.name}？`)
      },
      handleSuccess (response, file, fileList) {
        this.fileListTmp.push({
          uid: file.uid,
          name: file.name,
          url: response.data
        })
        this.$emit('fileList', this.fileListTmp)
      }
    }
  }
</script>

<style scoped>


</style>
